var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useUrlProps } from '../../common/urlProps';
import useLoginTheme from '../../common/useLoginTheme';
import AuthService from '../../domain/AuthService';
import { User } from '../../domain/Models';
import gs from '../../styles/style';
import { UserContext } from '../Auth/UserProvider';
import ErrorResponseHandler from '../Common/ErrorResponseHandler';
import { Errors, Form, Input, SubmitButton, useForm } from '../Common/Form';
import style from './Login.scss';
var FontAwesomeIcon = require('@fortawesome/react-fontawesome').FontAwesomeIcon;
var Login = function () {
    useLoginTheme();
    var t = useTranslation()[0];
    var urlProps = useUrlProps();
    var _a = useContext(UserContext), user = _a.user, setUser = _a.setUser;
    var form = useForm({
        values: {
            email: urlProps.get('email'),
        },
        onSubmit: AuthService.login,
        onSuccess: function (user) {
            setUser(new User(user));
        }
    });
    return React.createElement("div", { className: style['login-container'] },
        React.createElement(ErrorResponseHandler, null),
        React.createElement("h1", { className: gs('mb-5') }, t('lotus')),
        React.createElement("div", { className: gs('card') },
            React.createElement("div", { className: gs('card-body', style['login-form']) },
                React.createElement("h4", { className: gs('mt-2', 'text-center') },
                    React.createElement("span", { className: gs('text-muted') },
                        React.createElement(FontAwesomeIcon, { icon: "lock" })),
                    ' ',
                    t('log_in')),
                React.createElement("hr", { className: gs('mt-4', 'mb-4') }),
                React.createElement(Form, { form: form },
                    React.createElement("fieldset", null,
                        React.createElement("div", { className: gs('form-group') },
                            React.createElement("label", null, t('email_address')),
                            React.createElement(Input, __assign({}, form.email('email'), { autoFocus: !form.values.email, className: gs('form-control-lg'), required: true })),
                            React.createElement(Errors, { attribute: "email_address", errors: form.getErrors('email') })),
                        React.createElement("div", { className: gs('form-group', 'last') },
                            React.createElement("label", null, t('password')),
                            React.createElement(Input, __assign({}, form.password('password'), { autoFocus: form.values.email, className: gs('form-control-lg'), required: true })),
                            React.createElement(Errors, { attribute: "password", errors: form.getErrors('password') })),
                        form.getErrors('auth') && React.createElement("div", { className: gs('mb-3') },
                            React.createElement(Errors, { attribute: "auth", errors: form.getErrors('auth') })),
                        React.createElement(SubmitButton, { form: form, className: gs('btn-block', 'btn-lg') }, t('log_in')),
                        React.createElement("div", { className: gs('mt-4', 'text-center', 'text-small') },
                            React.createElement(Link, { to: "/request-password-reset".concat(urlProps.mergeLink({ email: form.values.email })), className: gs('text-muted') }, t('forgot_password'))))))));
};
export default Login;
